import {showNotification} from './notifications';

export const FETCH_API = 'FETCH_API',
    FETCH_API_SUCCESS = 'FETCH_API_SUCCESS',
    FETCH_API_ERROR = 'FETCH_API_ERROR';

const handleResponse = response => {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response.json();
};

export function fetchAPI(url, init = {
    method: 'GET',
    mode: 'cors',
    cache: 'default'
}) {
    return dispatch => {
        // console.warn(FETCH_API, url);
        dispatch({type: FETCH_API, url});
        return fetch(url, init)
            .then(handleResponse)
            .then(response => {
                // console.info(FETCH_API_SUCCESS, url, response);
                dispatch({type: FETCH_API_SUCCESS, url, response});
                return response;
            })
            .catch(error => {
                // console.error(FETCH_API_ERROR, url, error);
                dispatch({type: FETCH_API_ERROR, url, error});
                dispatch(showNotification({
                    header: 'Error',
                    content: error.message || `Could not fetch ${url}.`,
                    error: true
                }));
            });
    };
}


// WEBPACK FOOTER //
// ./src/actions/api.js